export default "__VITE_ASSET__d720b05f__"